export default __webpack_public_path__ + "static/media/sakura_footer.f18563ea.svg";